import { forwardRef, useState } from "react";
import { getPanelId, getTabId, type TabPanelProps, useTabContext } from "@mui/lab";
import { useNestedTabContext } from "./TabContext";

interface Props extends TabPanelProps {
  preserveChildren?: boolean;
  nestedValue?: string;
  renderImmediately?: boolean;
}

const TabPanel = forwardRef<HTMLDivElement, Props>(function TabPanel(props, ref) {
  const { children, className, classes, value, preserveChildren, nestedValue, renderImmediately, ...other } = props;
  const context = useTabContext();
  const activeNestedValue = useNestedTabContext();
  if (context === null) {
    throw new TypeError("No TabContext provided");
  }
  const id = getPanelId(context, value + "");
  const tabId = getTabId(context, value + "");

  const [hasRendered, setHasRendered] = useState(renderImmediately);

  let isActive;
  if (nestedValue) {
    isActive = nestedValue === activeNestedValue && value === context.value;
  } else {
    isActive = value === context.value;
  }

  if (isActive && !hasRendered) {
    setHasRendered(true);
  }

  return (
    <div
      aria-labelledby={tabId}
      className={className}
      hidden={!isActive}
      id={id}
      // @ts-expect-error - ref type mismatch
      ref={ref}
      role="tabpanel"
      {...other}
    >
      {(isActive || (preserveChildren && hasRendered)) && children}
    </div>
  );
});

export default TabPanel;
